import React, { useState } from 'react';
import PortalModal from '../../../common/PortalModal/PortalModal';

export default function ManagePoliciesModal({ role, policies, onAttach, onDetach, onClose }) {
  const [searchTerm, setSearchTerm] = useState('');

  if (!role) return null;

  const filteredPolicies = policies.filter(policy =>
    policy.policy_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    policy.description.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <PortalModal
      isOpen
      onClose={onClose}
      title={
        <>
          <i className="fas fa-link"></i>
          Manage Policies for {role.role_name}
        </>
      }
      size="large"
      bodyClassName="rbac-modal-body"
    >
      <div className="modal-body">
        <p style={{ marginBottom: '1rem', color: 'rgba(255, 255, 255, 0.7)' }}>
          Select policies to attach to this role. Users with this role will have the combined permissions from all attached policies.
        </p>

        <input
          type="text"
          className="search-input"
          placeholder="Search policies..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{ marginBottom: '1rem', width: '100%' }}
        />

        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          {filteredPolicies.map((policy) => {
            const isAttached = role.policies?.includes(policy.policy_id);
            return (
              <div
                key={policy.policy_id}
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '1rem',
                  background: 'rgba(255, 255, 255, 0.05)',
                  border: '1px solid rgba(255, 255, 255, 0.1)',
                  borderRadius: '8px',
                  gap: '1rem'
                }}
              >
                <div style={{ flex: 1 }}>
                  <strong style={{ color: '#fff', display: 'block', marginBottom: '0.25rem' }}>
                    {policy.policy_name}
                  </strong>
                  <p style={{ margin: 0, fontSize: '0.85rem', color: 'rgba(255, 255, 255, 0.7)' }}>
                    {policy.description}
                  </p>
                </div>
                <div style={{ flexShrink: 0 }}>
                  {isAttached ? (
                    <button
                      type="button"
                      className="btn btn-danger btn-sm"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        onDetach(policy.policy_id);
                      }}
                    >
                      <i className="fas fa-unlink"></i>
                      Detach
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="btn btn-primary btn-sm"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        onAttach(policy.policy_id);
                      }}
                    >
                      <i className="fas fa-link"></i>
                      Attach
                    </button>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </PortalModal>
  );
}
